import styled, { css } from 'styled-components';

export const InhouseJackpotButtonButtonWrapper = styled.div`
	height: ${props => {
		if (props.isDesktop) {
			return '36px';
		}

		return '28px';
	}};
	width: ${props => props.orientation === 'landscape' && '28px'};
	padding: 2px;
	border-radius: 25px;
	background-color: rgba(
		var(
			${props => {
				if (props.isDesktop) {
					return '--inhouse-jackpot--btn-bg-color--desktop';
				}

				return props.isOptedin
					? '--inhouse-jackpot--btn-bg-color--opted-in'
					: '--inhouse-jackpot--btn-bg-color';
			}}
		),
		1
	);
	border: ${props => {
		if (props.isDesktop) {
			return '';
		}
		return `2px solid rgba(var(${
			props.isOptedin ? '--inhouse-jackpot--btn-border-color--opted-in' : '--inhouse-jackpot--btn-border-color'
		}),1)`;
	}};
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	cursor: pointer;
	${props =>
		props.isDesktop &&
		css`
			margin-right: 12px;
		`}
`;

export const InhouseJackpotText = styled.span`
	font: var(--caption-bold);
	color: rgba(
		var(
			${props => {
				if (props.isDesktop) {
					return '--inhouse-jackpot--btn-text-color--desktop';
				}

				return props.isOptedin
					? '--inhouse-jackpot--btn-text-color--opted-in'
					: '--inhouse-jackpot--btn-text-color';
			}}
		),
		1
	);
	margin-left: ${props => (props.isDesktop ? '10px' : '6px')};
	margin-right: ${props => (props.isDesktop ? '8px' : '4px')};
	${props =>
		props.isDesktop &&
		css`
			font: var(--h4-bold);
		`}
	${props =>
		props.orientation === 'landscape' &&
		css`
			display: none;
		`}
`;

export const InhouseJackpotIconContainer = styled.div`
	width: 24px;
	height: 24px;
	color: rgba(
		var(
			${props => {
				if (props.isDesktop) {
					return props.isOptedin
						? '--inhouse-jackpot--icon-container-color--desktop--opted-in'
						: '--inhouse-jackpot--icon-container-color--desktop';
				}

				return props.isOptedin
					? '--inhouse-jackpot--icon-container-color--opted-in'
					: '--inhouse-jackpot--icon-container-color';
			}}
		),
		1
	);
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		fill: currentColor;
	}
	${props =>
		props.isDesktop &&
		css`
			background-color: rgba(
				var(
					${props.isOptedin
						? '--inhouse-jackpot--icon-container-bg-color--desktop--opted-in'
						: '--inhouse-jackpot--icon-container-bg-color--desktop'}
				),
				1
			);
			border-radius: 50%;
			width: 32px;
			height: 32px;
		`}
`;
